import { render } from "./BootstrapComponent.vue?vue&type=template&id=6e10c40e&scoped=true"
import script from "./BootstrapComponent.vue?vue&type=script&lang=js"
export * from "./BootstrapComponent.vue?vue&type=script&lang=js"

import "./BootstrapComponent.vue?vue&type=style&index=0&id=6e10c40e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e10c40e"]])

export default __exports__